module.exports = __webpack_public_path__ + "img/no-question-list.966b6e6a.png";